<template>
  <div class="centered-box">
    <slot />
    <div
      class="centered-box__child"
      :style="{ top: `calc(50% + ${ offsetY }px)` }">
      <slot name="child" />
    </div>
  </div>
</template>

<script>
/**
 * @description 囲んだコンポーネントの上下左右中央に要素を配置したいときに使用するコンポーネント
 */
export default {
  props: {
    offsetY: {
      type: Number,
      default: 0
    },
  }
}
</script>

<style lang="scss" scoped>
.centered-box {
  position: relative;
  &__child {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }
}
</style>